import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mainbody modulewrap"
};
const _hoisted_2 = {
  class: "subwrap2"
};
const _hoisted_3 = {
  key: 0,
  class: "subcontop"
};
const _hoisted_4 = {
  class: "subcontopinfo"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "subcontopcover"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "subconitem"
};
const _hoisted_9 = {
  class: "imgtitle"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "subconitem"
};
const _hoisted_12 = {
  class: "img1"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 0,
  class: "subconitem2"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 0,
  class: "subconitem3"
};
const _hoisted_17 = {
  class: "img3"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 0,
  class: "img3"
};
const _hoisted_20 = ["src"];
export default {
  __name: 'about',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const FFdata = reactive({
      alias: 'about',
      isLoad: false,
      listInfo: [],
      kindInfo: {},
      topTitle: ''
    });
    const getData = () => {
      proxy.$common.fetch({
        'act': 'sei_info',
        'exts': 'alias=' + FFdata.alias,
        msg: ''
      }, res => {
        proxy.$common.each(res.infodata, item => {
          item.imglist = [];
          if (item.imgs) {
            item.imglist = item.imgs.split(',');
          }
        });
        FFdata.listInfo = res.infodata;
        FFdata.kindInfo = res.infodatakind;
        FFdata.isLoad = true;
        FFdata.topTitle = res.infodatakind.title;
      });
      proxy.$store.SET_NAVALIAS(FFdata.alias);
    };
    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _directive_title = _resolveDirective("title");
      return _unref(FFdata).isLoad ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listInfo, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "subconlist",
          key: item.id
        }, [index == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
          class: "editor2",
          innerHTML: item.content
        }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_7)])])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
          src: item.cover
        }, null, 8, _hoisted_10)])]), index == 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [item.imgs ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
          src: item.imglist[0]
        }, null, 8, _hoisted_13)])]), item.imglist.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("img", {
          src: item.imglist[1]
        }, null, 8, _hoisted_15)])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [item.imgs ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
          src: item.imglist[0]
        }, null, 8, _hoisted_18)]), item.imglist.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("img", {
          src: item.imglist[1]
        }, null, 8, _hoisted_20)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64))], 64))]);
      }), 128))])])), [[_directive_title, _unref(FFdata).topTitle]]) : _createCommentVNode("", true);
    };
  }
};